'use client';
import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import { SparklesIcon } from '@heroicons/react/24/solid';


const ChatWidget = dynamic(() => import('@/components/ChatWidget'), { ssr: false });

export default function ChatWidgetLauncher() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-24 right-4 lg:bottom-28 lg:right-8 z-30 flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-bold shadow-lg transition-all hover:scale-105 active:scale-95 animate-pulse-glow"
        style={{ backgroundColor: 'var(--surface-2)', border: '1px solid rgba(57,255,20,0.3)', color: 'var(--text)' }}
        aria-label="Open AI Repair Assistant"
      >
        <SparklesIcon className="w-4 h-4" style={{ color: 'var(--brand)' }} />
        <span className="hidden sm:inline">AI Repair Assistant</span>
        <span className="sm:hidden">AI Help</span>
      </button>

      {open && <ChatWidget onClose={() => setOpen(false)} />}
    </>
  );
}